module.exports = "https://static.im-cdn.com/mjc/storefront/Melody/static/media/downArrow1.ec16c0f4.svg";